module.exports = __webpack_public_path__ + "static/media/ALC_GKB_Web_-5.974bf8e3.JPG";